import { Button, Chip, Stack } from '@mui/material';

import { CopyToClipboardButton } from 'common';

import { useReactFlowViewContext } from '../../../../../context/context';

interface ClinicalQuestionAssistantDefaultValueAdornmentProps {
  displayedValue: string;
  resetValue: () => void;
  valueState: 'Customized' | 'UsingDefault';
}

export function ClinicalQuestionAssistantDefaultValueAdornment(
  props: ClinicalQuestionAssistantDefaultValueAdornmentProps
) {
  const { displayedValue, resetValue, valueState } = props;
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Chip label={valueState === 'Customized' ? 'Customized' : 'Using default'} size="small" />
      {valueState === 'Customized' && (
        <Button
          size="small"
          disabled={!isEditable}
          onClick={() => {
            resetValue();
          }}
        >
          Reset to default
        </Button>
      )}
      <CopyToClipboardButton animationVariant="AlwaysVisible" content={displayedValue} />
    </Stack>
  );
}
